export default __webpack_public_path__ + "static/media/comm.f2c76fce.svg";